import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import { IDatadogLogger } from './IDatadogLogger';

import { DatadogLoggerService } from './DatadogLoggerService';

export class AggregateDatadogLogger implements IDatadogLogger {
  debug(message: string, messageContext?: object, error?: Error): void {
    ServiceContainer.get(DatadogLoggerService).forEach(logger => {
      try {
        logger.debug(message, messageContext, error);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to log debug message', e);
      }
    });
  }

  info(message: string, messageContext?: object, error?: Error): void {
    ServiceContainer.get(DatadogLoggerService).forEach(logger => {
      try {
        logger.info(message, messageContext, error);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to log info message', e);
      }
    });
  }

  warn(message: string, messageContext?: object, error?: Error): void {
    ServiceContainer.get(DatadogLoggerService).forEach(logger => {
      try {
        logger.warn(message, messageContext, error);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to log warn message', e);
      }
    });
  }

  error(message: string, messageContext?: object, error?: Error): void {
    ServiceContainer.get(DatadogLoggerService).forEach(logger => {
      try {
        logger.error(message, messageContext, error);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to log error message', e);
      }
    });
  }
}
